var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoGrasaCorporal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.298,
    height: 43.34,
    viewBox: "0 0 52.298 43.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13742 11637.878)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13833.549 -11786.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.361 148.126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.258,151.4a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,621.258,151.4Z",
    transform: "translate(-583.135 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.947,151.4a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,524.947,151.4Z",
    transform: "translate(-494.449 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.637,151.4a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,428.637,151.4Z",
    transform: "translate(-405.763 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.326,151.4a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,332.326,151.4Z",
    transform: "translate(-317.077 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.015,151.4a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,236.015,151.4Z",
    transform: "translate(-228.391 -148.126)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.705,151.4a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,139.705,151.4Z",
    transform: "translate(-139.705 -148.126)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.549 155.468)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.1,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,573.1,244.143Z",
    transform: "translate(-534.98 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,476.792,244.143Z",
    transform: "translate(-446.294 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.482,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,380.482,244.143Z",
    transform: "translate(-357.608 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.171,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,284.171,244.143Z",
    transform: "translate(-268.922 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.859,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,187.859,244.143Z",
    transform: "translate(-180.234 -240.868)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.549,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,91.549,244.143Z",
    transform: "translate(-91.549 -240.868)",
    fill: "#394f65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.747 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.413,244.143a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,669.413,244.143Z",
    transform: "translate(-669.413 -240.868)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.361 162.81)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.258,336.886a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,621.258,336.886Z",
    transform: "translate(-583.135 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.947,336.886a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,524.947,336.886Z",
    transform: "translate(-494.449 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.637,336.886a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,428.637,336.886Z",
    transform: "translate(-405.763 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.326,336.886a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,332.326,336.886Z",
    transform: "translate(-317.077 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.015,336.886a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,236.015,336.886Z",
    transform: "translate(-228.391 -333.611)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.705,336.886a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,139.705,336.886Z",
    transform: "translate(-139.705 -333.611)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.361 177.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.258,523.37a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,621.258,523.37Z",
    transform: "translate(-583.135 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.947,523.37a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,524.947,523.37Z",
    transform: "translate(-494.449 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.637,523.37a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,428.637,523.37Z",
    transform: "translate(-405.763 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.326,523.37a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,332.326,523.37Z",
    transform: "translate(-317.077 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.015,523.37a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,236.015,523.37Z",
    transform: "translate(-228.391 -520.095)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.705,523.37a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,139.705,523.37Z",
    transform: "translate(-139.705 -520.095)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.549 170.231)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.1,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,573.1,430.628Z",
    transform: "translate(-534.98 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,476.792,430.628Z",
    transform: "translate(-446.294 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.482,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,380.482,430.628Z",
    transform: "translate(-357.608 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.171,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,284.171,430.628Z",
    transform: "translate(-268.922 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.859,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,187.859,430.628Z",
    transform: "translate(-180.234 -427.353)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.549,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,91.549,430.628Z",
    transform: "translate(-91.549 -427.353)",
    fill: "#394f65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.747 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.413,430.628a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,669.413,430.628Z",
    transform: "translate(-669.413 -427.353)",
    fill: "#394f65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.549 184.915)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.1,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,573.1,616.112Z",
    transform: "translate(-534.98 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,476.792,616.112Z",
    transform: "translate(-446.294 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.482,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,380.482,616.112Z",
    transform: "translate(-357.608 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.171,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,284.171,616.112Z",
    transform: "translate(-268.922 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.859,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,187.859,616.112Z",
    transform: "translate(-180.234 -612.837)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.549,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,91.549,616.112Z",
    transform: "translate(-91.549 -612.837)",
    fill: "#394f65"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.747 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.413,616.112a3.275,3.275,0,1,0,3.275-3.275A3.279,3.279,0,0,0,669.413,616.112Z",
    transform: "translate(-669.413 -612.837)",
    fill: "#394f65"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGrasaCorporal);
export default __webpack_public_path__ + "static/media/ICO-GRASA-CORPORAL.ab78219a42b81a73b949c48ff12fa997.svg";
export { ForwardRef as ReactComponent };